/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Grid, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import AddIcon from '@mui/icons-material/Add';
import { groutWidthData } from '../room.data';

type GroutColorsAndSizeType = {
  groutColors: object;
  groutWidth: object;
  handleColorClick: (arg0: object) => void;
  handleColorDelete: (arg0: object) => void;
  handleAddColor: (arg0: object) => void;
  handleGroutWidth: (arg0: object) => void;
};

const GroutColorsAndSize = ({
  groutColors,
  groutWidth,
  handleColorClick,
  handleColorDelete,
  handleAddColor,
  handleGroutWidth,
}: GroutColorsAndSizeType) => {
  const { tileOne, tileTwo, tileThree, selected } = groutColors || {};

  const noTile = (tile) => (
    <Grid size={4} onClick={() => handleAddColor(tile)}>
      <Box className="PatternInfoBtn GroutWidth">
        <Box className="PatternInfoInner">
          <Typography variant="h6">
            <AddIcon className="OrangeColor" />
          </Typography>
          <Typography variant="body2">Add Color</Typography>
        </Box>
      </Box>
    </Grid>
  );

  return (
    <>
      {groutColors && (
        <Paper className="TileSelection">
          <Typography variant="h6" className="TitleOption">
            <b>Compare Grout Colors</b>
          </Typography>
          <Grid
            container
            direction="row"
            className=""
            columnSpacing={2}
            sx={{ justifyContent: 'center' }}
          >
            {tileOne ? (
              <Grid size={4}>
                <Box className={`GroutColour ${selected === 'tileOne' ? 'Selected' : ''}`}>
                  <Box
                    className="TileImageSecond"
                    style={{
                      backgroundColor: tileOne.backgroundColor,
                    }}
                    onClick={() => handleColorClick({ selected: 'tileOne' })}
                  >
                    {/* <Box className="CancelIcon"></Box> */}
                  </Box>
                  <Box
                    className="CancelIcon"
                    onClick={() => {
                      handleColorDelete('tileOne');
                    }}
                  >
                    <CancelRoundedIcon />
                  </Box>

                  <Typography variant="h6" className="GroutName">
                    <Box component="span">{tileOne.id}</Box>
                    {tileOne.name}
                  </Typography>
                </Box>
              </Grid>
            ) : (
              noTile('tileOne')
            )}
            {tileTwo ? (
              <Grid size={4}>
                <Box className={`GroutColour ${selected === 'tileTwo' ? 'Selected' : ''}`}>
                  <Box
                    className="TileImageSecond"
                    style={{
                      backgroundColor: tileTwo.backgroundColor,
                    }}
                    onClick={() => handleColorClick({ selected: 'tileTwo' })}
                  >
                    {/* <Box className="CancelIcon"></Box> */}
                  </Box>
                  <Box
                    className="CancelIcon"
                    onClick={() => {
                      handleColorDelete('tileTwo');
                    }}
                  >
                    <CancelRoundedIcon />
                  </Box>
                  <Typography variant="h6" className="GroutName">
                    <Box component="span">{tileTwo.id}</Box>
                    {tileTwo.name}
                  </Typography>
                </Box>
              </Grid>
            ) : (
              noTile('tileTwo')
            )}
            {tileThree ? (
              <Grid size={4}>
                <Box className={`GroutColour ${selected === 'tileThree' ? 'Selected' : ''}`}>
                  <Box
                    className="TileImageSecond"
                    style={{
                      backgroundColor: tileThree.backgroundColor,
                    }}
                    onClick={() => handleColorClick({ selected: 'tileThree' })}
                  >
                    {/* <Box className="CancelIcon"></Box> */}
                  </Box>
                  <Box
                    className="CancelIcon"
                    onClick={() => {
                      handleColorDelete('tileThree');
                    }}
                  >
                    <CancelRoundedIcon />
                  </Box>
                  <Typography variant="h6" className="GroutName">
                    <Box component="span">{tileThree.id}</Box>
                    {tileThree.name}
                  </Typography>
                </Box>
              </Grid>
            ) : (
              noTile('tileThree')
            )}
          </Grid>
        </Paper>
      )}
      <Paper className="TilePattern">
        <Typography variant="h6" className="TitleOption">
          <b>Grout Joint Width</b>
        </Typography>
        <Grid
          container
          direction="row"
          className=""
          columnSpacing={2}
          sx={{ justifyContent: 'flex-start' }}
        >
          {groutWidthData.map((g) => (
            <Grid key={g.id} size={4}>
              <Box
                className={`PatternInfoBtn GroutWidth ${groutWidth?.id === g.id ? 'Selected' : ''}`}
                onClick={() => handleGroutWidth(g)}
              >
                <Box className="PatternInfoInner">
                  <Typography variant="h6">{g.label1}</Typography>
                  <Typography variant="body2">{g.label2}</Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </>
  );
};

export default GroutColorsAndSize;
